import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {properties} from "../../../../../../environments/properties";
import {RewardService} from "../../../../../shared/services/reward.service";

declare var $: any;

@Component({
    selector: 'app-promotion-manifesto',
    templateUrl: './promotion-manifesto.component.html',
    styleUrl: './promotion-manifesto.component.scss'
})

export class PromotionManifestoComponent implements OnInit {
    @Input() partnerDetails: any;
    @Input() isWebView;
    manifestoContent: string = '';
    manifestoContentURL: any;
    displayableBanner: string = '';


    constructor(private rewardService: RewardService, private elementRef: ElementRef) {
    }

    ngOnInit(): void {
        if (this.partnerDetails) {
            this.displayableBanner = properties.rewardsConfig.displaybleBannerNames[this.partnerDetails.banner];
            if (this.partnerDetails.contentPath) {
                this.manifestoContentURL = this.partnerDetails.contentPath;
                if (this.isWebView) {
                    this.manifestoContentURL = this.rewardService.getMobileApplicationDomainURL(this.partnerDetails.currentEnvironment, this.partnerDetails.banner) + '/' + this.manifestoContentURL.replace(/\{partner_section\}/g, 'manifesto');
                } else {
                    this.manifestoContentURL = this.rewardService.getApplicationDomainURL() + '/' + this.manifestoContentURL.replace(/\{partner_section\}/g, 'manifesto');
                }
                this.getMenifestoContentAPI();
            }
        }

    }

    getMenifestoContentAPI() {
        this.rewardService.getPromotionDetailContent(this.manifestoContentURL).subscribe((manifestoData: any) => {
            if (manifestoData) {
                this.manifestoContent = this.rewardService.replaceBannerInContent(manifestoData, this.partnerDetails.banner);
            }
        }, error => {

        });
    }

}
